import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from './authService';

// Tarayıcı hafızasından kullanıcı bilgilerini al (sayfa yenilense bile girişin kalması için)
const userInfoFromStorage = JSON.parse(localStorage.getItem('userInfo'));

const initialState = {
  userInfo: userInfoFromStorage ? userInfoFromStorage : null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: '',
};

// Login işlemi için asenkron thunk
export const login = createAsyncThunk('auth/login', async (user, thunkAPI) => {
  try {
    return await authService.login(user);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

// Logout işlemi
export const logout = createAsyncThunk('auth/logout', async () => {
  await authService.logout();
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.userInfo = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.userInfo = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.userInfo = null;
      });
  },
});

export const { reset } = authSlice.actions;
export default authSlice.reducer;